import { render, staticRenderFns } from "../ItemSelectModal.html?vue&type=template&id=3e931be6&external"
import script from "./ProducerSelectModal.ts?vue&type=script&lang=ts&external"
export * from "./ProducerSelectModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports